import React,{ Component } from 'react';

import {Container} from 'reactstrap';

import Switch from 'react-router-dom/Switch';
import Route from 'react-router-dom/Route';
import Redirect from 'react-router-dom/Redirect';

import AgencyNavBar from './AgencyNavBar';
import AgencyIntroduction from './AgencyIntroduction';
import Loading from '../../../shared/components/Loading';

import NotificationTray from '../../../shared/components/NotificationTray';
import VersionTag from '../../../shared/components/VersionTag';

import GuidedCampaignCreation from '../../GuidedCampaignCreation';
import GuidedCampaignReview from '../../GuidedCampaignReview';
import EditBrand from '../../EditBrand';
import OwnerReviewCampaign from '../../OwnerReviewCampaign';
import AgencyCampaignsDashboard from '../../AgencyCampaignsDashboard';
import Help from '../../Help';
import Brands from '../../Brands';
import CampaignResultsPrint from '../../CampaignResultsPrint';
import EditUserNew from '../../EditUserNew';
import ManageUsers from '../../ManageUsers';
import ManageAccount from '../../ManageAccount';
import AgencyManageAccount from '../../AgencyManageAccount';
import NotFoundHelp from '../../NotFoundHelp';
import AgencyCreatePaymentMethod from '../../AgencyCreatePaymentMethod';
import AgencyAddFunds from '../../AgencyAddFunds';
import ImpersonationError from '../../ImpersonationError';
import DabblAudience from '../../DabblAudience';
import GuidedCampaignAudience from '../../GuidedCampaignAudience';

import { hideChatBox } from '../../../shared/utils';

import { HASH_URLS, ACTIVE_PROFILE } from '../../../config';

class AgencyPortal extends Component {
  constructor(){
    super();

    this.state = {
      impersonationError:null,
      authenticationError:null,
      isLoaded:false,
      isShowingIntro:false,
      isShowingIntroModal:true,
      hasStartedJoyRide:false,
      agencyName:null,
      agencyId:null,
      username:null
    };
  }

  componentDidMount(){
    if(this.props.isImpersonating || this.state.isShowingIntro){
      hideChatBox()
    }

    if(this.props.isFirstTime){
      this.setState({
        isShowingIntro:true
      });
    }

    if(this.props.isImpersonating){
      const redirectLink = HASH_URLS ? '/#/superadmin/accounts' : '/superadmin/accounts';

      const message = `You are now impersonating <strong>${this.props.impersonatingEmail}</strong>.  <a href=${redirectLink}>Go Back</a>`

      this.props.requestImpersonateTokenWithCredentials(this.props.impersonatingEmail)
        .then(() => this.props.loadImpersonatedUser())
        .then((res) => this.loadContentForUser(res))
        .then((results) => this.setState({ isLoaded:true}))
        .then(() => this.props.showNotification('info',message))
        .catch((err) => this.setState({impersonationError:err}));

    } else {
      this.props.loadActiveUser()
        .then((res) => this.loadContentForUser(res))
        .then((results) => this.setState({ isLoaded:true}))
        .catch((err) => this.setState({authenticationError:err.message}));
    }
  }

  componentDidUpdate(){
    if(this.props.isImpersonating || this.state.isShowingIntro){
      hideChatBox()
    }
  }

  loadContentForUser(result){
    const agencyId = result.instance.agencyId;

    if(agencyId === 'mynfo'){
      return Promise.reject(new Error('The link you requested is not available to superadmin users.  Please use account credentials to continue.'));
    } else {
      return Promise.all([
        result,
        this.props.loadKPIsForAgency(agencyId),
        this.props.loadAgencyWithChildren(agencyId)
      ]);
    }
  }

  handleSignOutClick(){
    this.props.invalidateImpersonateToken();
    this.props.invalidateAuthToken();
    this.props.history.push('/login');
  }

  handleIntroComplete(){
    this.props.completeIntro();
    this.props.updateUser(this.props.user.id,{hasCompletedIntroduction:true});
  }

  isBlueNavbar(){
    return this.props.location.pathname.endsWith('experiences') || this.props.location.pathname.endsWith('audience');
  }

  render(){
    const {
      match,
      isLoggedIn,
      pathname,
      user,
      agency,
      dismissNotification,
      notifications,
      shouldForceOpenProfileMenu,
      isImpersonating,
      hasSeenIntro,
      environment,
      frontEndVersion,
      backEndVersion      
    } = this.props;

    const {
      isLoaded,
      authenticationError,
      impersonationError
    } = this.state;



    if(impersonationError){
      return ( <ImpersonationError /> );
    }


    if(authenticationError){
      return(
        <Redirect
          push
          to={{
            pathname:'/login',
            state:{
              from: pathname,
              message: authenticationError
            }
          }}
        />
      );
    }



    if(!isLoggedIn){
      return(
        <Redirect
          push
          to={{
            pathname:'/login',
            state:{
              from: pathname
            }
          }}
        />
      );
    }

    if(!isLoaded){
      return (
        <Loading />
      );
    }

    return (
      <div className='AgencyPortal'>
        {ACTIVE_PROFILE !== 'prod' && ( 
          <VersionTag 
            environment={environment}
            frontend={frontEndVersion}
            backend={backEndVersion}
          /> 
        )}
        <div>
          <AgencyNavBar
            agencyName={agency.name}
            isDashboard={this.isBlueNavbar()}
            profileMenuIsForcedOpen={shouldForceOpenProfileMenu}
            userIsAdmin={user.isOwner}
            currentURL={match.url}
            avatarUserName={`${user.firstName} ${user.lastName}`}
            avatarURL={user.avatarURL}
            build={`Build ${frontEndVersion}-${backEndVersion}`}
            onSignOutClick={() => this.handleSignOutClick()}
          />
          <NotificationTray
            notifications={notifications}
            onDismiss={(notificationId) => dismissNotification(notificationId)}
          />
        </div>
        {user.isOwner ? (
          <Switch>
            <Route 
              exact path={`${match.url}/experiences/create/:campaignId`} 
              render={(routeProps) => (
                <Container>
                  <GuidedCampaignCreation 
                    {...routeProps}
                    agencyId={agency.id}
                    showSuperadminFeatures={false}
                    isOnboarding={false}
                    backURL={`${match.url}/experiences`}
                    forwardURL={`${match.url}/experiences/audience/${routeProps.match.params.campaignId}`}
                  />
                </Container>
              )}
            />
            <Route 
              exact path={`${match.url}/experiences/:campaignId/edit`} 
              render={(routeProps) => (
                <Container>
                  <GuidedCampaignCreation 
                    {...routeProps}
                    agencyId={agency.id}
                    showSuperadminFeatures={false}
                    isOnboarding={false}
                    backURL={`${match.url}/experiences`}
                    forwardURL={`${match.url}/experiences/audience/${routeProps.match.params.campaignId}`}
                  />
                </Container>
              )}
            />
            <Route 
              exact path={`${match.url}/experiences/audience/:campaignId`} 
              render={(routeProps) => (
                <Container>
                  <GuidedCampaignAudience 
                    {...routeProps}
                    agencyId={agency.id}
                    showSuperadminFeatures={false}
                    isOnboarding={false}
                    backURL={`${match.url}/experiences/create/${routeProps.match.params.campaignId}`}
                    forwardURL={`${match.url}/experiences/review/${routeProps.match.params.campaignId}`}
                  />
                </Container>
              )}
            />
            <Route 
              exact path={`${match.url}/experiences/review/:campaignId`} 
              render={(routeProps) => (
                <Container>
                  <GuidedCampaignReview 
                    {...routeProps}
                    agencyId={agency.id}
                    showSuperadminFeatures={false}
                    isOnboarding={false}
                    forwardURL={`${match.url}/experiences`}
                    allowCreateNewMethod
                    backURL={`${match.url}/experiences/audience/${routeProps.match.params.campaignId}`}
                  />
                </Container>
              )}
            />
            <Route exact path={`${match.url}/experiences/:campaignId/review`} component={OwnerReviewCampaign} />
            <Route exact path={`${match.url}/experiences/:campaignId/responses`} component={CampaignResultsPrint} />
            <Route exact path={`${match.url}/experiences`} component={AgencyCampaignsDashboard} />
            <Route exact path={`${match.url}/brands/:brandId`} component={EditBrand} />
            <Route exact path={`${match.url}/brands`} component={Brands} />
            <Route path={`${match.url}/help`} component={Help} />
            <Route exact path={`${match.url}/users/new`} component={EditUserNew} />
            <Route exact path={`${match.url}/users/:userId`} component={EditUserNew} />
            <Route exact path={`${match.url}/users`} component={ManageUsers} />
            <Route exact path={`${match.url}/profile`} component={EditUserNew} />
            <Route exact path={`${match.url}/payment/new`} component={AgencyCreatePaymentMethod} />
            <Route exact path={`${match.url}/billing/new`} component={AgencyAddFunds} />
            <Route path={`${match.url}/account`} component={ManageAccount} />
            <Route path={`${match.url}/audience`} component={DabblAudience} />
            <Route component={NotFoundHelp} />
          </Switch>
        ) : (
          <Switch>
            <Route exact path={`${match.url}/brands/:brandId`} component={EditBrand} />
            <Route exact path={`${match.url}/brands`} component={Brands} />
            <Route 
              exact path={`${match.url}/experiences/create/:campaignId`} 
              render={(routeProps) => (
                <Container>
                  <GuidedCampaignCreation 
                    {...routeProps}
                    agencyId={agency.id}
                    showSuperadminFeatures={false}
                    isOnboarding={false}
                    backURL={`${match.url}/experiences`}
                    forwardURL={`${match.url}/experiences/audience/${routeProps.match.params.campaignId}`}
                  />
                </Container>
              )}
            />
            <Route 
              exact path={`${match.url}/experiences/:campaignId/edit`} 
              render={(routeProps) => (
                <Container>
                  <GuidedCampaignCreation 
                    {...routeProps}
                    agencyId={agency.id}
                    showSuperadminFeatures={false}
                    isOnboarding={false}
                    backURL={`${match.url}/experiences`}
                    forwardURL={`${match.url}/experiences/audience/${routeProps.match.params.campaignId}`}
                  />
                </Container>
              )}
            />
            <Route 
              exact path={`${match.url}/experiences/audience/:campaignId`} 
              render={(routeProps) => (
                <Container>
                  <GuidedCampaignAudience 
                    {...routeProps}
                    agencyId={agency.id}
                    showSuperadminFeatures={false}
                    isOnboarding={false}
                    backURL={`${match.url}/experiences/create/${routeProps.match.params.campaignId}`}
                    forwardURL={`${match.url}/experiences/review/${routeProps.match.params.campaignId}`}
                  />
                </Container>
              )}
            />
            <Route 
              exact path={`${match.url}/experiences/review/:campaignId`} 
              render={(routeProps) => (
                <Container>
                  <GuidedCampaignReview 
                    {...routeProps}
                    agencyId={agency.id}
                    showSuperadminFeatures={false}
                    isOnboarding={false}
                    forwardURL={`${match.url}/experiences`}
                    backURL={`${match.url}/experiences/audience/${routeProps.match.params.campaignId}`}
                    allowCreateNewMethod={false}
                  />
                </Container>
              )}
            />
            <Route exact path={`${match.url}/experiences/:campaignId/review`} component={OwnerReviewCampaign} />
            <Route exact path={`${match.url}/experiences/:campaignId/responses`} component={CampaignResultsPrint} />
            <Route exact path={`${match.url}/experiences`} component={AgencyCampaignsDashboard} />
            <Route path={`${match.url}/help`} component={Help} />
            <Route exact path={`${match.url}/profile`} component={EditUserNew} />
            <Route path={`${match.url}/audience`} component={DabblAudience} />
            <Route component={NotFoundHelp} />
          </Switch>
        )}
        <AgencyIntroduction
          show={!isImpersonating && !hasSeenIntro}
          onStart={() => this.props.startIntro()}
          onStep={() => this.props.advanceIntro()}
          onCompletion={() => this.handleIntroComplete()}
        />
      </div>
    );
  }
}

AgencyPortal.propTypes = {
  // username:PropTypes.string.isRequired,
  // version:PropTypes.string.isRequired,
  // hasAdminPermission:PropTypes.bool.isRequired,
  // linkBase:PropTypes.string.isRequired,
  // breadCrumbLinks:PropTypes.arrayOf(PropTypes.string)
};


export default AgencyPortal;



// WEBPACK FOOTER //
// ./src/routes/AgencyPortal/components/AgencyPortal.js